import './Panellogout.css';

import { FormattedMessage, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { pure } from 'recompose';

const Panellogout = ({
  header,
  footer,
  double,
  triple,
  children,
  noScroll,
  noLoading,
  shaded,
  loading
}) => (
  <div
    className={cx({
      Panellogout: true,
      double,
      triple,
      loading: loading && !noLoading
    })}
  >
    {loading &&
      !noLoading && (
        <div className="panel__loading">
          <div className="spinner">
            <FormattedMessage id="panel.loading" defaultMessage="Loading..." />
          </div>
        </div>
      )}
    {header && <div className="panellogout__header">{header}</div>}
    <div
      className={cx({ panellogout__body: true, shaded })}
      style={{
        overflowY: noScroll ? 'visible' : 'auto'
      }}
    >
      {(!loading || noLoading) && children}
    </div>
    {footer && <div className="panellogout__footer">{footer}</div>}
  </div>
);

Panellogout.propTypes = {
  header: PropTypes.element,
  footer: PropTypes.element,
  double: PropTypes.bool,
  triple: PropTypes.bool,
  noScroll: PropTypes.bool,
  shaded: PropTypes.bool,
  loading: PropTypes.bool,
  noLoading: PropTypes.bool,
  intl: PropTypes.object
};

export default pure(injectIntl(Panellogout));



// WEBPACK FOOTER //
// ./src/components/elements/Panellogout/index.js